
import React from 'react';

const RoleSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            Role of Safety Managers and Coordinators
          </h2>
          
          <p className="text-lg text-gray-700 mb-8">
            Safety managers and coordinators' roles are pivotal in ensuring effective safety management. These professionals carry extensive and multifaceted responsibilities central to maintaining safe working environments.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12">
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Core Responsibilities
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-search-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Conducting regular safety audits</h4>
                  <p className="text-gray-600 text-sm">Systematic evaluation of workplace safety conditions</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-presentation-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Presenting safety orientations</h4>
                  <p className="text-gray-600 text-sm">Comprehensive safety training for new personnel</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-group-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Delivering training and toolbox meetings</h4>
                  <p className="text-gray-600 text-sm">Regular safety education and updates</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-file-text-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Preparing job hazard analyses</h4>
                  <p className="text-gray-600 text-sm">Detailed risk assessment documentation</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-shield-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Writing site-specific safety plans</h4>
                  <p className="text-gray-600 text-sm">Customized safety protocols for each project</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Impact on Productivity & Success
            </h3>
            
            <p className="text-gray-700 mb-6">
              Safety management is pivotal in ensuring compliance with regulatory standards, enhancing project success, and potentially winning bids on new contracts. Safety managers who uphold regulatory standards and reduce the risk of accidents and incidents lead to a more efficient and uninterrupted workflow.
            </p>
            
            <div className="bg-green-50 p-6 rounded-lg border-l-4 border-green-500">
              <h4 className="font-semibold text-green-800 mb-3">Benefits Include:</h4>
              <ul className="space-y-2 text-green-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1"></i>
                  Reduced workplace injuries and incidents
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1"></i>
                  Improved project timelines and completion
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1"></i>
                  Enhanced workforce productivity and engagement
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1"></i>
                  Better compliance with OSHA standards
                </li>
              </ul>
            </div>
            
            <div className="mt-6 text-center">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Learn More About Our Services
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoleSection;
